module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.6d2b8854.mp3";